import { call, fork, put, race } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import { errorAction } from 'components/utility/actions';
import SystemClient, { SystemStatusClient } from 'rest/SystemClient';
import * as actions from './actions';

export const systemStatusClient = new SystemStatusClient();
export const systemClient = new SystemClient();

export function wait(timeout) {
	return new Promise(resolve => setTimeout(resolve, timeout));
}

export function *triggerRestart() {
	try {
		yield call([ systemClient, systemClient.restart ]);
	} catch (err) {
		// Don't bother with any errors
	}
}

/**
 * Ping the server until status is ok.
 */
export async function doAwaitRestart(payload, abort) {
	let status;
	try {
		const response = await systemStatusClient.get();
		status = response.data.statusMessage === 'ok';
	} catch (err) {
		status = false;
	}

	if (status) {
		return status;
	}

	// Wait before checking status again
	await wait(payload.checkInterval);

	if (abort.aborted) {
		return false;
	}
	return doAwaitRestart(payload, abort);
}

export async function doTimeout(timeout, abort) {
	await wait(timeout);
	abort.aborted = true;
	return true;
}

export function *awaitRestart(action) {
	try {
		const abort = {
			aborted: false
		};

		yield call(wait, action.payload.initialDelay);

		const { timeout } = yield race({
			success: call(doAwaitRestart, action.payload, abort),
			timeout: call(doTimeout, action.payload.timeout, abort)
		});

		if (timeout) {
			yield put({ type: actions.AWAIT_RESTART_TIMEOUT });
		} else {
			yield put({ type: actions.AWAIT_RESTART_SUCCESS });
		}
	} catch (error) {
		yield put(errorAction(actions.AWAIT_RESTART_ERROR, error, action));
	}
}

export default function *sagas() {
	yield fork(takeLatest, actions.AWAIT_RESTART, awaitRestart);
	yield fork(takeLatest, actions.TRIGGER_RESTART, triggerRestart);
}
